import React from 'react';
import { Link } from 'react-router-dom';
import { FiInstagram, FiFacebook, FiYoutube } from 'react-icons/fi';
import SubscribeForm from '../ui/SubscribeForm';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Desktop Footer */}
        <div className="hidden md:block py-12">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Company Info */}
            <div>
              <h3 className="text-2xl font-bold mb-4">BeyondXL</h3>
              <p className="text-gray-400 mb-6">
                Fresh Fits, Fresh Feels. Your destination for premium men's fashion.
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/products" className="text-gray-400 hover:text-white transition-colors">
                    All Products
                  </Link>
                </li>
                <li>
                  <Link to="/collections" className="text-gray-400 hover:text-white transition-colors">
                    Collections
                  </Link>
                </li>
                <li>
                  <Link to="/returns" className="text-gray-400 hover:text-white transition-colors">
                    Returns, Exchanges & Refunds
                  </Link>
                </li>
                <li>
                  <Link to="/terms" className="text-gray-400 hover:text-white transition-colors">
                    Terms & Conditions
                  </Link>
                </li>
                <li>
                  <Link to="/privacy" className="text-gray-400 hover:text-white transition-colors">
                    Privacy Policy
                  </Link>
                </li>
              </ul>
            </div>

            {/* Newsletter */}
            <div>
              <h4 className="text-lg font-semibold mb-4">Stay Updated</h4>
              <p className="text-gray-400 mb-4">
                Subscribe for new arrivals and exclusive offers on WhatsApp.
              </p>
              <SubscribeForm source="footer" variant="dark" />
            </div>
          </div>

          {/* Social Section */}
          <div className="border-t border-gray-800 mt-8 pt-8">
            <div className="flex flex-col gap-6 lg:flex-row lg:items-start lg:justify-between">
            <div className="text-center lg:text-left">
              <h4 className="text-lg font-semibold">100% Secure Payment</h4>
            </div>
            <div className="flex flex-col items-center lg:items-end">
              <h4 className="text-lg font-semibold mb-4 text-center lg:text-right">Join The beyondxl Squad</h4>
              <div className="flex items-center space-x-4">
                <button type="button" aria-label="Facebook" className="text-gray-400 hover:text-white transition-colors">
                  <FiFacebook size={24} />
                </button>
                <a href="https://www.instagram.com/beyondxl.in?igsh=MTRtbTFjNXRsNDlzag==" className="text-gray-400 hover:text-white transition-colors">
                  <FiInstagram size={24} />
                </a>
                <button type="button" aria-label="YouTube" className="text-gray-400 hover:text-white transition-colors">
                  <FiYoutube size={24} />
                </button>
              </div>
              <div className="text-gray-400 text-sm mt-6 text-center lg:text-right">
                © 2026 BeyondXL. All rights reserved.
              </div>
            </div>
            </div>
          </div>
        </div>

        {/* Mobile Footer - Simplified */}
        <div className="md:hidden py-8">
          {/* Company Info */}
          <div className="text-center mb-6">
            <h3 className="text-xl font-bold mb-2">BeyondXL</h3>
            <p className="text-gray-400 text-sm">
              Fresh Fits, Fresh Feels
            </p>
          </div>

          {/* Social Media */}
          <div className="text-center mb-6">
            <h4 className="text-sm font-semibold mb-3">Join The beyondxl Squad</h4>
            <div className="flex justify-center items-center space-x-4">
              <button type="button" aria-label="Facebook" className="text-gray-400 hover:text-white transition-colors">
                <FiFacebook size={20} />
              </button>
              <a href="https://www.instagram.com/beyondxl.in?igsh=MTRtbTFjNXRsNDlzag==" className="text-gray-400 hover:text-white transition-colors">
                <FiInstagram size={20} />
              </a>
              <button type="button" aria-label="YouTube" className="text-gray-400 hover:text-white transition-colors">
                <FiYoutube size={20} />
              </button>
            </div>
          </div>

          {/* Subscribe */}
          <div className="text-center mb-6 px-4">
            <h4 className="text-sm font-semibold mb-2">Stay Updated</h4>
            <p className="text-gray-400 text-xs mb-3">
              Get new arrivals and offers on WhatsApp.
            </p>
            <SubscribeForm source="footer-mobile" variant="dark" />
          </div>

          {/* Essential Links */}
          <div className="text-center mb-6">
            <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-sm">
              <Link to="/products" className="text-gray-400 hover:text-white transition-colors">
                Products
              </Link>
              <Link to="/collections" className="text-gray-400 hover:text-white transition-colors">
                Collections
              </Link>
              <Link to="/returns" className="text-gray-400 hover:text-white transition-colors">
                Returns
              </Link>
              <Link to="/terms" className="text-gray-400 hover:text-white transition-colors">
                Terms
              </Link>
              <Link to="/privacy" className="text-gray-400 hover:text-white transition-colors">
                Privacy
              </Link>
            </div>
          </div>

          {/* Copyright */}
          <div className="border-t border-gray-800 pt-6 text-center">
            <div className="text-gray-400 text-xs">
              © 2026 BeyondXL. All rights reserved.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 